import withAemIntegration from "../../../../withAemIntegration";
import loadable from "../../../../utils/loadable";

const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/DriversResendEmailForm")
);

const ComponentEditConfig = {
  emptyLabel: "Resend Activation Email",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const ResendEmail = (props) => {
  return (
    <>
      <Component {...props} />
    </>
  );
};

export default withAemIntegration(
  "lexus/components/drivers/forms/resend-email"
)(ResendEmail, ComponentEditConfig);
